import React from 'react'
import Icon from './icon'
import Header from './header'
import './section.css'

/**
 * Section
 */
class Section extends React.Component {

  componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.props.open) {
      this.toggle()
      console.log('section', nextProps)
    }
  }

  static defaultProps = {
    open: true
  }

  state = {
    open: this.props.open
  }

  toggle = () => {
    const {onToggle} = this.props
    if (onToggle) onToggle(!this.state.open)
    this.setState({ open: !this.state.open })
  }

  renderToggler = () => {
    const icon = this.state.open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
    return this.props.horizontal  ? '' : (
      <Icon icon={icon} clickable className="toggler square" action={this.toggle}/>
    )
  }

  renderBody = () => {
    const className= this.props.lane ? 'lane' : ''
    return this.state.open === true ? (
      <main className={className}>{this.props.children}</main>
    ) : ''
  }

  render() {
    const stateClass =  this.state.open === true ? '' : 'closed'
    return (
      <section className={`section ${stateClass}`}>
        <Header {...this.props}>
          {this.props.actions ? this.props.actions : ''}
          {this.props.toggler ? this.renderToggler() : ''}
        </Header>
        {this.renderBody()}
      </section>
    )
  }
}

export default Section



// WEBPACK FOOTER //
// ./src/lib/components/section.js